<template>
  <div :class="['alert', `alert-${notification.status}`, {'alert-dismissible': notification.dismissible}]" role="alert">
    <button
      type="button"
      class="close social-step-editor-sidebar-advanced-link-notification__close"
      data-dismiss="alert"
      aria-label="Close"
      @click="$emit('close')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
    {{ notification.message }}
  </div>
</template>

<script>
import SharedStepEditorInputField from '../../../shared/form/SharedStepEditorInputField';
import SharedStepEditorInputCounter from '../../../shared/form/SharedStepEditorInputCounter';

export default {
  components: {SharedStepEditorInputField, SharedStepEditorInputCounter},
  props: {
    notification: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.social-step-editor-sidebar-advanced-link-notification {
  &__close {
    background: transparent;
  }
}
</style>
